import { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { UseSupplierRequest } from "./UseSupplierRequest";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import DeleteRow from "../../components/DeleteRow";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";

export default function SuppliersList(props) {
  const [supplierRes, setSupplierRes] = useState([]);
  const { cancelRequest, sendSMS } = UseSupplierRequest();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    if (props.items) {
      setSupplierRes(props.items);
    }
  }, [props.items]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "companyName",
      headerName: "نام شرکت",
      width: 170,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.companyName}
          </Typography>
        );
      },
    },
    {
      field: "visitor",
      headerName: "نام ویزیتور",
      width: 170,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.visitor ? cellValues.row.visitor : "-"}
          </Typography>
        );
      },
    },
    {
      field: "visitorMobile",
      headerName: "شماره ویزیتور",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.visitorMobile ? cellValues.row.visitorMobile : "-"}
          </Typography>
        );
      },
    },
    {
      field: "companyMobile",
      headerName: "شماره شرکت",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.companyMobile ? cellValues.row.companyMobile : "-"}
          </Typography>
        );
      },
    },

    {
      field: "isConfirm",
      headerName: "تایید",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isConfirm ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "isEnable",
      headerName: "فعال",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isEnable ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "cancel",
      headerName: "لغو",
      width: 120,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Button
            disabled={!cellValues.row.isEnable}
            color="secondary"
            variant="contained"
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.companyName,
                id: cellValues.row.id,
              });
            }}
          >
            لغو درخواست
          </Button>
        );
      },
    },
    {
      field: "sendSMS",
      width: 110,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderHeader: (cellValues) => {
        return (
          <Button
            onClick={() => {
              setCheckState({
                show: true,
                name: "ارسال SMS",
              });
            }}
            variant="contained"
            color="secondary"
          >
            ارسال SMS
          </Button>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem" }}>
      <Typography sx={{ my: 2 }} color="secondary" variant="subtitle1">
        تامین کنندگان:
      </Typography>
      <DataGrid
        disableVirtualization
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        rows={supplierRes ?? []}
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={supplierRes && supplierRes.length ? supplierRes.length : 1}
        enableRangeSelection={true}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            nofab: true,
            rowCount:
              supplierRes && supplierRes.length ? supplierRes.length : 1,
          },
        }}
        sx={{
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "&  .MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "&  .MuiDataGrid-cell:focus-within ": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          "& .MuiDataGrid-cell:hover": {
            opacity: "80%",
            cursor: "pointer",
          },
          "& .MuiDataGrid-virtualScrollerRenderZone": {
            width: "100% !important",
          },

          "& .red": {
            backgroundColor: "#ff9c9c !important",
          },
        }}
        getRowClassName={(params) => {
          if (!params.row.isEnable) {
            return "red";
          }
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "rowIndex",
                sort: "asc",
              },
            ],
          },
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"درخواست از تامین کننده"}
        callback={() => {
          setProgress(true);
          cancelRequest(deleteState.id, () => {
            props.callback(props.requestID);
          });
        }}
      ></DeleteRow>
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          let state = {
            ID: props.requestID,
          };
          setProgress(true);
          sendSMS(state, () => {
            setCheckState({
              show: false,
              name: "ارسال SMS",
            });
          });
        }}
      />
    </Box>
  );
}
